// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Layout_selectedTracker__Ed2LC {
  color: black;
  text-decoration: underline;
  text-underline-offset: 15px;
  text-decoration-color: #a1a1a1;
}

.Layout_nonSelectedTracker__ef1an {
  color: grey;
}

.Layout_homePageTracker__f5\\+LF {
  color: black;
}`, "",{"version":3,"sources":["webpack://./src/components/templates/Layout.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,0BAAA;EACA,2BAAA;EACA,8BAAA;AACF;;AAEA;EACE,WAAA;AACF;;AACA;EACE,YAAA;AAEF","sourcesContent":[".selectedTracker {\r\n  color: black;\r\n  text-decoration: underline;\r\n  text-underline-offset: 15px;\r\n  text-decoration-color: #a1a1a1;\r\n}\r\n\r\n.nonSelectedTracker {\r\n  color: grey;\r\n}\r\n.homePageTracker {\r\n  color: black;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectedTracker": `Layout_selectedTracker__Ed2LC`,
	"nonSelectedTracker": `Layout_nonSelectedTracker__ef1an`,
	"homePageTracker": `Layout_homePageTracker__f5+LF`
};
export default ___CSS_LOADER_EXPORT___;
